import { ArrowRight } from 'lucide-react';

import content from '../../data/content.js';

import portrait from "../../files/images/PICTURES/portrait.jpg";
import portraitPen from "../../files/images/PICTURES/portrait_pen.jpg";
import portraitNy from "../../files/images/PICTURES/portrait_ny.jpg";

import "./Hero.css";

const Hero = ({ lang }) => {
  const t = content[lang].hero;

  return (
    <section className="hero-section">
      <div className="deco-img-container pos-1">
         <img src= { portrait } alt="Portrait" />
      </div>
      <div className="deco-img-container pos-2">
         <img src={ portraitNy } alt="New York Vessel" />
      </div>
      <div className="deco-img-container pos-3">
         <img src={ portraitPen } alt="Pen face drawing" />
      </div>

      <div className="hero-title-container">
        <h1 className="hero-text italic">{t.titleLine1}</h1>
        <h1 className="hero-text offset">{t.titleLine2}</h1>
      </div>
      
      <div className="hero-bio">
        <p>{t.bio}</p>
      </div>
      <div className="hero-arrow">
        <ArrowRight className="icon-rotate" />
      </div>
    </section>
  );
};

export default Hero;